export default {
    videoPreview: 'Video Preview',
    buttonLabelUpload: 'Upload New',
    buttonLabelVideo: 'Video',
    buttonLabelPhoto: 'Photo',
    generateMagic: 'Generate Magic',
    isUploadingText: 'Uploading video. Please wait ...',
} as const;
